/** Map of Azure AD tenant (object) ID → Crimson tenant slug. */
export type TenantsById = Record<string, string>;

/** Approved tenants keyed by deployment environment (e.g. "productionuk"). */
export type ApprovedTenants = Record<string, TenantsById>;

// List of approved tenant IDs that can access the application
export const approvedTenants: ApprovedTenants = {
  'devvv': {
    'd3d9e8e6-05d3-4691-9def-4d5a573dfc56': 'test',
    '41b02f2a-fc73-40bc-a859-5bc3d899251e': 'test',
  },
  'test': {
    'd3d9e8e6-05d3-4691-9def-4d5a573dfc56': 'test',
    '41b02f2a-fc73-40bc-a859-5bc3d899251e': 'crimsontest',
    '9330018f-4627-43bd-b69e-e80dfbe8e76b': 'grainkitchen',
  },
  'demo': {
    'd3d9e8e6-05d3-4691-9def-4d5a573dfc56': 'demo',
  },
  'productionuk': {
    'd3d9e8e6-05d3-4691-9def-4d5a573dfc56': 'crimson',
    '41b02f2a-fc73-40bc-a859-5bc3d899251e': 'crimsonlegal',
    '59795af8-5516-4b6f-94d9-2d89c6347c76': 'onsidelaw',
    '6d84d497-a8cf-4435-bc8a-f8e89e0e8f4f': 'squareonelaw',
    'f02c16e2-2394-4b46-ba2b-74e81a54605b': 'humphrieskerst',
    'b601610b-06ec-4746-a776-6caddd4c97a6': 'russells',
    '4f4bc185-f6bf-4588-951b-a15de2a114f6': 'mantlelaw',
    '1e8fce74-a6d3-4c52-b9e6-3e0ebde1cce1': 'gunnercooke',
    '328802f6-1bd7-4944-a180-db24736ceadb': 'youssefpartners',
    '6bab23fb-1f0f-4e76-b2e3-5e6e392b38b8': 'ghaffarifussel',
    '57eb176e-af34-4d86-b6c5-15e8363b8a22': 'clarion',
    '0f6c170f-8ed4-460b-8772-224f1a986329': 'hoganlovells',
    '97e63f85-720d-495c-ac0a-7c62fa6a8e17': 'aslegal',
    '2ef495cc-a5ba-4998-89a6-66f6aa0c0cb0': 'peterspeters',
    '8e877f77-950e-4917-8432-5deca26b6bac': 'duanemorris',
    'a53c63ba-e989-4640-af00-7157c63b8531': 'mcevedys',
    'a624746c-1251-4e99-b4e7-7cde33622ca8': 'thomsonsnell',
  },
  'productionus': {
    'd3d9e8e6-05d3-4691-9def-4d5a573dfc56': 'crimsonus',
    '41b02f2a-fc73-40bc-a859-5bc3d899251e': 'crimsonlegalus',
    'ec6df6dd-e165-4aaf-83ff-984ddf3bedab': 'hexagon',
    '0dc5b99f-9a86-4c58-89fb-9806325e0254': 'fbfk',
    'd422c216-f033-4ae2-a3fc-364c3cb5dab9': 'gruenstein',
    '4552612b-c86a-4ab1-8739-40c420f0e306': 'donbivens',
    '3f4603c7-ccb6-4c12-9846-1886f18ecdd1': 'webergal',
  },
};
